export * from '../src/registries'
export { default as registerWidgetForMarkers } from '../src/markers/registry'
